export default __webpack_public_path__ + "static/squares-476227397624cdc9f988828ac271f29d.png";